import { initSentry } from '@cloneai/observability';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App.js';
import { VoiceCaptureApp } from './VoiceCaptureApp.js';
import { ErrorBoundary } from './components/ErrorBoundary.js';
import { env } from './env.js';
import { consumeVoiceCaptureRoute } from './voiceCaptureRoute.js';
import './index.css';

// Force env validation at startup — throws on bad config so we fail loud
// rather than shipping a broken bundle to prod.
void env;

// Consume the bearer fragment before telemetry starts so it cannot appear in
// Sentry's initial page context. Ordinary agent routes preserve their hashes.
const voiceCaptureRoute = consumeVoiceCaptureRoute({
  location: window.location,
  storage: window.sessionStorage,
  replaceUrl: (url) => window.history.replaceState(null, '', url),
});

// Must run after bearer-fragment removal and before React renders.
initSentry({
  app: 'agent',
  environment: env.VITE_APP_ENV,
  release: env.VITE_SENTRY_RELEASE,
  dsn: env.VITE_SENTRY_DSN,
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Missing #root element in index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <ErrorBoundary>
      {voiceCaptureRoute ? (
        <VoiceCaptureApp captureId={voiceCaptureRoute.captureId} token={voiceCaptureRoute.token} />
      ) : (
        <App />
      )}
    </ErrorBoundary>
  </StrictMode>,
);
